import { BASE_URL } from "@/services/api/base";

export const getDocumentsEndpoint = `${BASE_URL}/Documents/Get`;
export const getDocumentsSingleEndpoint = `${BASE_URL}/Documents/GetSingle`;
export const getRequiredDocumentsEndpoint = `${BASE_URL}/Documents/GetRequiredDocuments`;
export const getContractorDocumentsEndpoint = `${BASE_URL}/Documents/GetContractorDocuments`;
export const getSubContractorDocumentEndpoint = `${BASE_URL}/Documents/GetSubContractorDocument`;
